import { useEffect, useState } from "react";
import { FileText, User } from "lucide-react";
import { api } from "../lib/api";

export const useFileUrl = (path) => {
  const [state, setState] = useState({ url: null, type: null });
  useEffect(() => {
    if (!path) return;
    let url;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setState({ url, type: r.data.type }); })
      .catch(() => setState({ url: null, type: null }));
    return () => url && URL.revokeObjectURL(url);
  }, [path]);
  return state;
};

export const AuthImage = ({ path, className, testId }) => {
  const { url, type } = useFileUrl(path);
  if (!url) return <div className={`flex items-center justify-center bg-muted ${className}`} data-testid={testId}><User className="h-1/3 w-1/3 opacity-40" /></div>;
  if (type === "application/pdf")
    return (
      <a href={url} target="_blank" rel="noreferrer" className={`flex flex-col items-center justify-center gap-2 bg-muted text-sm ${className}`} data-testid={testId}>
        <FileText className="h-8 w-8" /> PDF
      </a>
    );
  return <img src={url} alt="" className={`object-cover ${className}`} data-testid={testId} />;
};
